import { OpenAPI, VaultService } from '@api'

import { addFailedMedia } from '@/models/vault/medias/errors.ts'
import { parseCreatorId, removeQueryParams } from '@/utils/url.ts'

const imageErrorListener = async (event: ErrorEvent) => {
  if (!(event.target instanceof HTMLImageElement)) {
    return
  }

  const url = event.target?.src

  if (event.target?.tagName?.toLowerCase() === 'img' && url) {
    // originalUrl exists only we once failed to load the asset
    if (event.target.dataset.originalUrl) {
      addFailedMedia(event.target.dataset.originalUrl)
    } else if (
      !!OpenAPI.TOKEN &&
      url.startsWith('https://of-assets.creatorhero.com/')
    ) {
      const chUrl = removeQueryParams(url)

      if (chUrl) {
        event.target.dataset.originalUrl = event.target.src

        try {
          const source = await VaultService.downloadFileV3({
            creatorId: parseCreatorId(url),
            chUrl,
          })

          event.target.src = URL.createObjectURL(source)
        } catch (error) {
          addFailedMedia(event.target.src)
        }
      }
    }
  }
}

document.addEventListener('error', imageErrorListener, true)
